import { lazy } from "react";

// AMD Coverage (módulo 41, key `amd_coverage`): relación del roster de
// Availity con AdvancedMD + vinculación por lookup by-dob. El acceso lo
// gobierna la matriz RBAC vía ROUTE_TO_MODULE_KEY ('/amd-coverage').
// Guía: docs/modulos/Coverage/MODULO_41_AMD_COVERAGE_GUIA_FRONTEND.md

// Feature flag del proyecto: en false el módulo exporta [] y la ruta no se monta.
const AMD_COVERAGE_ENABLED = true;

const AmdCoveragePage = lazy(() => import("./AmdCoveragePage"));

export const amdCoverageRoutes = AMD_COVERAGE_ENABLED
  ? [{ path: "/amd-coverage", element: <AmdCoveragePage /> }]
  : [];
